import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {USE_GET_USER_PROFILE_KEY, useGetUserProfile} from "@/hooks/useGetUserProfile";
import {useGetUserLevel} from "@/hooks/useGetUserLevel";
import {updateAccountLevel} from "@/redux/meta/metaActions";
import {RewardType} from "@devour/client";
import {useQueryClient} from "@tanstack/react-query";


export default function useRefreshRewardData() {
    const queryClient = useQueryClient();
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const {data: currentUser} = useGetUserProfile(fullToken);
    const dispatch = useDispatch();
    const {refetch: refetchUserLevel} = useGetUserLevel(fullToken, currentUser?.user?.id, true);

    const refetch = async (rewardType: string, isGuildReward?: boolean) => {
        if (rewardType === RewardType.FUEL || rewardType === "FUEL") {
            queryClient.invalidateQueries({ queryKey: ["transactions", "transactions-paginated"]});
        } else if (rewardType === RewardType.XP || rewardType === "XP") {
            queryClient.invalidateQueries({queryKey: [USE_GET_USER_PROFILE_KEY]});

            const {data: userLevelData} = await refetchUserLevel();
            if (userLevelData) {
                dispatch(updateAccountLevel(userLevelData));
            }
        } else if (rewardType === RewardType.NFT || rewardType === "NFT") {
            queryClient.invalidateQueries({ queryKey: ["get-nft-ownerships"]});
            queryClient.invalidateQueries({ queryKey: ["nft-ownerships"]});

            if (isGuildReward) {
                queryClient.invalidateQueries({ queryKey: ["guild-ownerships"]});
            }
        }
    };

    return {refetch};
}